import { useState } from "react";
import { curSym } from "../../../../utils/pip";
import { adminPaths } from "../../../../routes/admin";
import SendMessageModal from "../../SendMessageModal";
import { useDispatch, useSelector } from "react-redux";
import NoRecordSmall from "../../../form/NoRecordSmall";
import { useLocation, useNavigate } from "react-router-dom";
import { findAJobPaths } from "../../../../routes/find-a-job";
import { hireTalentPaths } from "../../../../routes/hire-talent";
import { getStatusLabel, StatusDefinitions } from "../../../../utils/data";
import { setIsViewProjectDetails } from "../../../../redux/features/find-a-job/reducers/projectReducer";
import {
  fetchMyProjects,
  manageInvitation,
} from "../../../../redux/features/find-a-job/actions/projectAction";
import toast from "react-hot-toast";
import { getSocket } from "../../../../redux/features/chat/socket";

const ProjectDetails = ({
  onClose,
  setConfirmation,
  setProjectId,
  deliveableList,
  projectList,
}) => {
  const socket = getSocket();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [isSendMessage, setIsSendMessage] = useState(false);
  const [currentReceiverId, setCurrentReceiverId] = useState("");
  const { projectData } = useSelector((state) => state?.hireTalent?.project);

  const projectDetails = projectList ? projectList : projectData;

  const project = projectList
    ? projectList?.project
    : projectDetails?.project || {};
  const BLOCKED_MESSAGE_STATUSES = ["invited", "rejected"];

  const handleRequest = (action) => {
    const callback = (res) => {
      if (res?.success) {
        dispatch(fetchMyProjects());
        dispatch(setIsViewProjectDetails(false));
      }
    };
    dispatch(
      manageInvitation({
        payload: { project_id: project?.id, action },
        callback,
      }),
    );
  };

  const handleSendMessage = (status) => {
    if (BLOCKED_MESSAGE_STATUSES.includes(status)) {
      toast.error(
        status === "invited"
          ? "You can send a message only after the freelancer accepts the project invitation."
          : "You can’t send a message because this freelancer rejected the project invitation.",
      );
      return;
    }

    // allowed
    setIsSendMessage(true);
  };

  return (
    <>
      <div
        class="modal fade modal-lg show d-block ct_congratulation_modal_fade"
        id="ct_project_detail_modal"
      >
        <div
          class="modal-dialog modal-dialog-centered ct_modal-dialog "
          style={{ maxWidth: "700px" }}
        >
          <div class="modal-content ct_p_30 ct_border_radius_20">
            <div class="modal-header border-0 p-0 ct_mb_30">
              <div className="d-flex align-items-start gap-3 justify-content-between  ct_flex_col_767">
                <div>
                  <h4 class="mb-1 ct_fs_20">
                    {project?.project_title || "#N/A"}
                  </h4>
                  <p class="mb-0 ct_grey_text">
                    Client:{" "}
                    {`${project?.client_first_name} ${project?.client_last_name}`}
                  </p>
                </div>
              </div>
              <button
                type="button"
                class="btn-close ct_circle_close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={onClose}
              ></button>
            </div>
            <div class="modal-body p-0">
              <div
                className={`d-flex align-items-center justify-content-${
                  pathname == hireTalentPaths?.MyProjects ? "between" : "end"
                } gap-3  mb-3 ct_flex_col_575`}
              >
                {pathname == adminPaths?.JobProject &&
                  project?.status != "completed" &&
                  project?.status != "pending" &&
                  project?.status != "dismissed" && (
                    <button
                      className="ct_yellow_btn ct_h_35 ct_w_100_575"
                      onClick={() =>
                        navigate(adminPaths?.InviteProject, {
                          state: { id: project?.id },
                        })
                      }
                    >
                      <i className="fa-solid fa-plus me-1 ct_fs_12"></i> Invite
                      Freelancer
                    </button>
                  )}
                {pathname == findAJobPaths?.MyProjects &&
                  projectDetails?.my_member_status == "invited" && (
                    <div className="d-flex align-items-center gap-3 justify-content-end ct_w_100_575">
                      <button
                        className="ct_yellow_btn ct_h_35 ct_w_100_575"
                        style={{
                          backgroundColor: "#57b04c",
                          borderColor: "#57b04c",
                        }}
                        type="button"
                        onClick={() => {
                          handleRequest("accept");
                        }}
                      >
                        Accept
                      </button>
                      <button
                        className="ct_yellow_btn ct_outline_grey text-white ct_h_35 ct_w_100_575"
                        style={{
                          backgroundColor: "#ff0000",
                          borderColor: "#ff0000",
                        }}
                        type="button"
                        onClick={() => {
                          handleRequest("reject");
                        }}
                      >
                        Reject
                      </button>
                    </div>
                  )}
                {pathname == findAJobPaths?.MyProjects &&
                  projectDetails?.my_member_status == "accepted" && (
                    <div className="d-flex align-items-center gap-3 justify-content-end ct_w_100_575">
                      <button
                        className="ct_yellow_btn ct_h_35 ct_w_100_575"
                        style={{
                          backgroundColor: "#57b04c",
                          borderColor: "#57b04c",
                        }}
                        type="button"
                      >
                        Accepted
                      </button>
                    </div>
                  )}
                {pathname == findAJobPaths?.MyProjects &&
                  projectDetails?.my_member_status == "rejected" && (
                    <div className="d-flex align-items-center gap-3 justify-content-end ct_w_100_575">
                      <button
                        className="ct_yellow_btn ct_outline_grey text-white ct_h_35 ct_w_100_575"
                        style={{
                          backgroundColor: "#ff0000",
                          borderColor: "#ff0000",
                          cursor: "unset",
                        }}
                        type="button"
                      >
                        Rejected
                      </button>
                    </div>
                  )}
              </div>
              <div class="row">
                <div class="col-lg-6 ct_mb_20">
                  <div class="ct_outline_bg h-100">
                    <h4 class="ct_fs_14 ct_mb_20 ct_darkblue_text">
                      Project Information
                    </h4>
                    <ul class="ct_activity_grid_2">
                      <li>
                        <span class="ct_fs_12">Title : </span>
                        <span
                          class="ct_fs_12 ct_para_scroll ct_custom_scroll"
                          style={{ maxHeight: "80px" }}
                        >
                          {project?.project_title || ""}
                        </span>
                      </li>
                      <li>
                        <span class="ct_fs_12">Skills :</span>
                        <span class="ct_fs_12">
                          {project?.project_categories?.join(", ") || ""}
                        </span>
                      </li>
                      <li>
                        <span class="ct_fs_12">Status :</span>
                        <span class="ct_fs_12" style={{ color: "#219EBC" }}>
                          {" "}
                          {getStatusLabel(project?.status)}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-6 ct_mb_20">
                  <div class="ct_outline_bg h-100">
                    <h4 class="ct_fs_14 ct_mb_20 ct_darkblue_text">
                      Project Budget
                    </h4>
                    <ul class="ct_activity_grid_2">
                      <li>
                        <span class="ct_fs_12">Client Name :</span>
                        <span class="ct_fs_12">{`${project?.client_first_name} ${project?.client_last_name}`}</span>
                      </li>
                      <li>
                        <span class="ct_fs_12">Project ID :</span>
                        <span class="ct_fs_12">
                          #{project?.project_unique_id || "N/A"}
                        </span>
                      </li>
                      <li>
                        <span class="ct_fs_12">Duration :</span>
                        <span class="ct_fs_12">
                          {project?.project_duration || "0"}
                          {project?.duration_type || ""}
                        </span>
                      </li>
                      <li className="mb-0">
                        <span class="ct_fs_12">Budget :</span>
                        <span class="ct_fs_12">
                          {curSym} {parseInt(project?.budget) || "#N/A"}
                          {/* (Fixed) */}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-6 ct_mb_20">
                  {project?.project_description && (
                    <div class="ct_outline_bg h-100">
                      <h4 class="ct_fs_14 ct_mb_20 ct_darkblue_text">
                        Project Brief
                      </h4>
                      <p className="ct_para_scroll ct_custom_scroll ct_fs_12 ct_darkblue_text mb-0">
                        {project?.project_description}
                      </p>
                    </div>
                  )}
                </div>
                {pathname != findAJobPaths?.MyProjects && (
                  <div className="col-lg-6 ct_mb_20">
                    <div class="ct_outline_bg h-100">
                      <h4 class="ct_fs_14 ct_mb_20 ct_darkblue_text">
                        Assigned To
                      </h4>
                      <div className="table-repsonsive">
                        <table className="table ct_transparent_table">
                          <thead>
                            <tr>
                              <th>Full Name</th>
                              <th>Status</th>
                              {pathname != findAJobPaths?.MyProjects && (
                                <th>Action</th>
                              )}
                            </tr>
                          </thead>
                          {projectDetails?.members?.length <= 0 && (
                            <tr>
                              <td colSpan={2}>
                                <NoRecordSmall />
                              </td>
                            </tr>
                          )}
                          <tbody>
                            {projectDetails?.members?.length != 0 &&
                              projectDetails?.members?.map((item, index) => (
                                <tr>
                                  <td className="ct_fs_12">
                                    {" "}
                                    {`${item?.first_name} ${item?.last_name}`}
                                  </td>
                                  <td className="ct_fs_12">
                                    {console.log({ item })}
                                    <span
                                      class={`ct_badge ct_fs_12 text-capitalize ${
                                        StatusDefinitions?.assignTo[
                                          item?.status
                                        ]?.color
                                      }`}
                                      style={
                                        StatusDefinitions?.assignTo[
                                          item?.status
                                        ]?.style
                                      }
                                    >
                                      {
                                        StatusDefinitions?.assignTo[
                                          item?.status
                                        ]?.value
                                      }
                                    </span>
                                  </td>
                                  {pathname != findAJobPaths?.MyProjects && (
                                    <td className="ct_fs_12">
                                      <span class="ct_fs_12">
                                        <span
                                          className="ct_yellow_text ct_cursor_pointer"
                                          style={{
                                            textDecoration: "underline",
                                          }}
                                          // onClick={() => {
                                          //   setIsSendMessage(true);
                                          // }}
                                          onClick={() => {
                                            setCurrentReceiverId(item?.user_id);
                                            handleSendMessage(item?.status);
                                          }}
                                        >
                                          Send Message
                                        </span>
                                      </span>
                                    </td>
                                  )}
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
                {deliveableList?.length != 0 && (
                  <div class="col-lg-6 ct_mb_20">
                    <div class="ct_outline_bg h-100">
                      <h4 class="ct_fs_14 ct_mb_20 ct_darkblue_text">
                        Uploaded Deliverable Files
                      </h4>
                      <ul class="ct_activity_grid_2">
                        {deliveableList?.map(
                          (item) =>
                            item?.files?.length != 0 &&
                            item?.files?.map((items) => (
                              <li>
                                <span class="ct_fs_12">
                                  Uploaded by{" "}
                                  {item?.is_owner
                                    ? "You"
                                    : item?.uploader_name || ""}{" "}
                                  :{" "}
                                </span>
                                <span className="ct_fs_12 ct_cursor_pointer">
                                  <a
                                    href={items?.file_url}
                                    download
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {items?.file_name || ""}
                                  </a>
                                </span>
                              </li>
                            )),
                        )}
                      </ul>
                    </div>
                  </div>
                )}
                {/* {deliveableList?.length > 0 && (
                  <div class="col-lg-6 ct_mb_20">
                    <div class="ct_outline_bg h-100">
                      <h4 class="ct_fs_14 ct_mb_20 ct_darkblue_text">
                        Links
                      </h4>
                      <ul class="ct_activity_grid_2">
                        {deliveableList?.map(
                          (item) =>
                            item?.links?.length != 0 &&
                            item?.links?.map((items) => (
                              <li>
                                <span class="ct_fs_12">
                                  Uploaded by{" "}
                                  {item?.is_owner
                                    ? "You"
                                    : item?.uploader_name || ""}{" "}
                                  :{" "}
                                </span>
                                <span class="ct_fs_12">
                                  <a href={items?.link_url} target="_blank">
                                    {items?.link_url}
                                  </a>
                                </span>
                              </li>
                            )),
                        )}
                      </ul>
                    </div>
                  </div>
                )} */}
                <div className="col-lg-12 ct_mb_20">
                  <div class="ct_outline_bg h-100">
                    <h4 class="ct_fs_14 ct_mb_20 ct_darkblue_text">
                      Deliverables & Milestones
                    </h4>
                    <div className="table-repsonsive">
                      <table className="table ct_transparent_table">
                        <thead>
                          <tr>
                            <th>Task</th>
                            <th>Status</th>
                            <th>Due Date</th>
                          </tr>
                        </thead>
                        {projectDetails?.members?.length <= 0 && (
                          <tr>
                            <td colSpan={2}>
                              <NoRecordSmall />
                            </td>
                          </tr>
                        )}
                        <tbody>
                          {projectDetails?.members?.length != 0 &&
                            projectDetails?.members?.map((item, index) => (
                              <tr>
                                <td className="ct_fs_12">
                                  {" "}
                                  {`${item?.first_name} ${item?.last_name}`}
                                </td>
                                <td className="ct_fs_12">
                                  {console.log({ item })}
                                  <span
                                    class={`ct_badge ct_fs_12 text-capitalize ${
                                      StatusDefinitions?.assignTo[item?.status]
                                        ?.color
                                    }`}
                                    style={
                                      StatusDefinitions?.assignTo[item?.status]
                                        ?.style
                                    }
                                  >
                                    {
                                      StatusDefinitions?.assignTo[item?.status]
                                        ?.value
                                    }
                                  </span>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 ct_mb_20">
                  <div class="ct_outline_bg h-100">
                    <h4 class="ct_fs_14 ct_mb_20 ct_darkblue_text">
                      Comments & Updates
                    </h4>
                    <div className="table-repsonsive">
                      <table className="table ct_transparent_table">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Message</th>
                            <th>Attachment</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="ct_fs_12">June 28</td>
                            <td className="ct_fs_12">
                              <span className="ct_overlay_text d-inline-block">
                                Uploaded first version of hoomepage
                              </span>
                            </td>
                            <td className="ct_fs_12">homepage_v1.fig</td>
                          </tr>
                          <tr>
                            <td className="ct_fs_12">July 2</td>
                            <td className="ct_fs_12">
                              <span className="ct_overlay_text d-inline-block">
                                Waiting on color guide confirmation
                              </span>
                            </td>
                            <td className="ct_fs_12">-</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                {pathname != hireTalentPaths?.MyProjects && (
                  <div class="col-lg-6 ct_mb_20">
                    <div class="ct_outline_bg h-100">
                      <h4 class="ct_fs_14 ct_mb_20 ct_darkblue_text">
                        Client Details
                      </h4>
                      <ul class="ct_activity_grid_2">
                        <li>
                          <span class="ct_fs_12">Client Name : </span>
                          <span class="ct_fs_12">{`${project?.client_first_name} ${project?.client_last_name}`}</span>
                        </li>
                        <li>
                          <span class="ct_fs_12">Company :</span>
                          <span class="ct_fs_12">
                            {project?.company_name || "#N/A"}
                          </span>
                        </li>
                        <li>
                          <span class="ct_fs_12">Role :</span>
                          <span class="ct_fs_12">
                            {project?.role_in_project || "#N/A"}
                          </span>
                        </li>
                        <li>
                          <span class="ct_fs_12">Email:</span>
                          <span class="ct_fs_12">
                            {project?.client_email || "#N/A"}
                          </span>
                        </li>
                        <li>
                          <span class="ct_fs_12">Message:</span>
                          <span class="ct_fs_12">
                            <span
                              className="ct_yellow_text ct_cursor_pointer"
                              style={{ textDecoration: "underline" }}
                              onClick={() => {
                                if (pathname == findAJobPaths?.MyProjects) {
                                  console.log({
                                    my_member_status:
                                      projectDetails?.my_member_status,
                                  });
                                  if (
                                    projectDetails?.my_member_status === "invited"
                                  ) {
                                    toast.error(
                                      "Please accept the project invitation first to start messaging.",
                                    );
                                    return;
                                  }

                                  if (
                                    projectDetails?.my_member_status === "rejected"
                                  ) {
                                    toast.error(
                                      "You cannot send a message because you rejected the project invitation.",
                                    );
                                    return;
                                  }
                                }
                                console.log({project})

                                setCurrentReceiverId(project?.client_id);
                                setIsSendMessage(true);
                              }}
                            >
                              Send Message
                            </span>
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
            {pathname != findAJobPaths?.MyProjects &&
              !projectDetails?.is_mark_completed &&
              project?.status == "active" && (
                <div class="d-flex align-items-center gap-3 justify-content-end ct_mt_30">
                  <button
                    type="button"
                    class="ct_yellow_btn px-5 ct_h_44"
                    onClick={() => {
                      setConfirmation(true);
                      onClose();
                      setProjectId(project?.id);
                    }}
                  >
                    Mark as Complete
                  </button>
                </div>
              )}
          </div>
        </div>
      </div>

      {isSendMessage && (
        <SendMessageModal
          onClose={() => {
            setIsSendMessage(false);
          }}
          hendleSendMessage={(text) => {
            socket?.emit("send_message", {
              receiver_id: currentReceiverId,
              message_text: text,
            });

            setIsSendMessage(false);
          }}
        />
      )}
    </>
  );
};

export default ProjectDetails;
